<Select
  inputAttributes={{ 'data-name': name, autocomplete: `${name}-${Math.random()}` }}
  items={options}
  {groupBy}
  selectedValue={selectedOption}
  isMulti={multiple}
  on:blur
  on:focus
  on:clear={() => (value = multiple ? [] : undefined)}
  on:select={({ detail }) => {
    if (multiple) {
      // detail will be null if they pressed the clear button
      value = detail ? detail.map((item) => item.value) : []
    } else {
      value = detail ? detail.value : undefined
    }
  }}
/>

<!-- Since Select doesn't actually update its input element's value property, if we want to be able to submit this form normally, we have to add this hidden field which actually contains the current value -->
<input type="hidden" {name} value={value || ''} />

<!-- <div>value: {JSON.stringify(value)}</div> -->
<!-- <div>selectedOption: {JSON.stringify(selectedOption)}</div> -->

<!-- -->
<script lang="ts">
  import Select from 'svelte-select'
  import { languageSelectOptions as options, getLanguageFromBrowser } from '@svelte/common/languages'

  export let multiple = false
  let defaultValue = getLanguageFromBrowser()
  if (multiple) {
    defaultValue = [defaultValue]
  }
  export let name
  export let value = defaultValue
  let selectedOption
  $: {
    if (Array.isArray(value)) {
      selectedOption = options.filter((option) => value.includes(option.value))
    } else {
      selectedOption = options.filter((option) => value === option.value)[0]
    }
    console.log(defaultValue, value, selectedOption)
  }

  const groupBy = (item) => item.group

  // console.log(options)
</script>
